<template>
  <a-menu mode="horizontal" :selected-keys="[current]">

    <a-menu-item key="hyperion.transaction.summary">
      <a :href="routeUri('hyperion.transaction.summary')">
        <a-icon type="project"/>
        All
      </a>
    </a-menu-item>

    <a-menu-item key="hyperion.transaction.summary.product">
      <a :href="routeUri('hyperion.transaction.summary.product')">
        <a-icon type="qrcode"/>
        Product
      </a>
    </a-menu-item>

    <a-menu-item key="hyperion.transaction.summary.biller">
      <a :href="routeUri('hyperion.transaction.summary.biller')">
        <a-icon type="deployment-unit"/>
        Biller
      </a>
    </a-menu-item>

    <a-menu-item key="hyperion.transaction.summary.client">
      <a :href="routeUri('hyperion.transaction.summary.client')">
        <a-icon type="solution"/>
        Client
      </a>
    </a-menu-item>
  </a-menu>
</template>
<script>
export default {
  props: {
    current: {
      type: String,
      required: true
    }
  }
}
</script>
